import React, { useEffect, useRef, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { ProjectCheckBoxLabel } from "../common/styled/project";

const InputField = ({
  isAddDesc,
  setIsAddDesc,
  formData,
  changeInput,
  setFormData,
  handleFocus,
  handleBlur,
  projectInfo,
  checkDuplProjectNm,
}) => {
  const user = useSelector((state) => state?.user?.data[0]);
  const company = useSelector((state) => state?.company?.data);

  const [options, setOptions] = useState([]);

  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  // 프로젝트 타입 선택 처리
  const handleProjectTypeChange = useCallback(
    (gbn) => {
      if (projectInfo) {
        toast.error("프로젝트 생성 후에는 수정이 불가합니다.");
        return;
      }
      setFormData((prev) => ({ ...prev, gbn }));
    },
    [projectInfo, setFormData],
  );

  // 내 모임 목록 조회
  const fetchMyGroups = useCallback(async () => {
    try {
      const response = await axios.post("/api/groupCondList", {
        mberNo: user.mberNo,
        delYn: "N",
        offset: 0,
        pageNumber: 0,
        pageSize: 10,
        paged: false,
      });

      const groups = response.data.content || [];

      if (groups.length > 0) {
        const groupOptions = groups.map((item) => ({
          name: item.groupName,
          value: item.groupNo,
        }));

        setOptions(groupOptions);
        setFormData((prev) => ({ ...prev, orgNo: groups[0].groupNo }));
      } else {
        setOptions([]);
        setFormData((prev) => ({ ...prev, orgNo: null }));
      }
    } catch (error) {
      console.error("모임 목록 조회 오류:", error);
      setOptions([]);
    }
  }, [user.mberNo, setFormData]);

  // 내 회사 목록 설정
  const setupCompanyOptions = useCallback(() => {
    if (!company || !Array.isArray(company)) {
      setOptions([]);
      setFormData((prev) => ({ ...prev, orgNo: null }));
      return;
    }

    const companyOptions = company.map((item) => ({
      name: item.cmpnyNm,
      value: item.cmpnyNo,
    }));

    setOptions(companyOptions);
    setFormData((prev) => ({
      ...prev,
      orgNo: company.length > 0 ? company[0].cmpnyNo : null,
    }));
  }, [company, setFormData]);

  // 프로젝트 타입에 따른 옵션 로드
  useEffect(() => {
    if (formData.gbn === "G") {
      fetchMyGroups();
    } else {
      setupCompanyOptions();
    }
  }, [formData.gbn, fetchMyGroups, setupCompanyOptions]);

  return (
    <ul className="projectInputField">
      <li className="projectName">
        <input
          type="text"
          placeholder="프로젝트 명을 입력하세요."
          name="projectNm"
          value={formData.projectNm}
          onChange={changeInput}
          onFocus={() => handleFocus("projectNm")}
          onBlur={() => handleBlur("projectNm")}
          ref={inputRef}
        />
        <button onClick={checkDuplProjectNm}>중복 확인</button>
      </li>
      <li className="selectButtons">
        <span>어느 프로젝트인지 설정해주세요.</span>
        <div>
          <button
            onClick={() => handleProjectTypeChange("C")}
            className={formData.gbn === "C" ? "active" : ""}>
            업무
          </button>
          <button
            onClick={() => handleProjectTypeChange("G")}
            className={formData.gbn === "G" ? "active" : ""}>
            모임
          </button>
        </div>
      </li>
      <li>
        <select name="orgNo" onChange={changeInput} value={formData.orgNo || ""}>
          {options.length > 0 ? (
            options.map((item, index) => (
              <option key={`${item.value}-${index}`} value={item.value}>
                {item.name}
              </option>
            ))
          ) : (
            <option value="" disabled>
              {formData.gbn === "G" ? "모임이 존재하지 않습니다." : "회사가 존재하지 않습니다."}
            </option>
          )}
        </select>
      </li>
      <li>
        <button
          className="descAddButton"
          onClick={() => setIsAddDesc((prev) => !prev)}
          type="button">
          설명 입력{isAddDesc ? " 취소" : ""}
        </button>
      </li>
      <li>
        {isAddDesc && (
          <textarea
            placeholder="프로젝트 설명을 입력해주세요."
            value={formData.projectDesc}
            name="projectDesc"
            onChange={changeInput}
            onFocus={() => handleFocus("projectDesc")}
            onBlur={() => handleBlur("projectDesc")}></textarea>
        )}
      </li>
      <li>
        <ProjectCheckBoxLabel>
          <span>참여자에게만 공개</span>
          <input
            type="checkbox"
            checked={formData.publicYn === "N"}
            onChange={changeInput}
            name="publicYn"
          />
        </ProjectCheckBoxLabel>
      </li>
    </ul>
  );
};

export default InputField;
